import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

/** Matches Figma Score Section circle: 10px surface padding around the 100px donut. */
const HALO_PADDING = 10;

type Props = {
	/** Diameter of the donut the halo sits behind. */
	size: number;
};

/**
 * Surface-colored circle behind a single overlapping summary donut so the ring
 * keeps a padded surface backing where it pops above the summary card.
 */
export const SessionReportDonutSurfaceHalo = ({ size }: Props) => {
	const theme = useAppTheme();
	const haloSize = size + HALO_PADDING * 2;

	return (
		<Box
			position="absolute"
			pointerEvents="none"
			width={haloSize}
			height={haloSize}
			borderRadius={haloSize / 2}
			backgroundColor={theme.colors.surface}
			top={-HALO_PADDING}
			left={-HALO_PADDING}
			style={{ borderCurve: "continuous" }}
		/>
	);
};
